module.exports = __webpack_public_path__ + "static/media/STS.54ff4059.pdf";